import { createSlice } from "@reduxjs/toolkit";

const defaultFormValueInsurance = {
    status: "",
    rejection_reason: "",
};

const initialState = {
    // insurance state
    showDrawerInsurance: false,
    formTypeInsurance: "",
    initialValuesInsurance: { ...defaultFormValueInsurance },
    paginationInsurance: {
        pageNo: 0,
        limit: 10,
        sortBy: "DESC",
        sortField: "created_at",
        keywords: "",
    },
    // filters
    filtersInsurance: {
        product_id: null,
        start_date: null,
        end_date: null,
    },
    // selected insurance for details
    selectedInsurance: null,
    showInsuranceDetails: false,
};

export const insuranceSlice = createSlice({
    name: "insurance",
    initialState,
    reducers: {
        // insurance state
        changeInsuranceInitialState: (state, action) => {
            const { showDrawer, formType, initialValues } = action.payload;

            state.showDrawerInsurance = showDrawer;
            if (formType) state.formTypeInsurance = formType;
            if (initialValues) state.initialValuesInsurance = initialValues;
            if (!initialValues) state.initialValuesInsurance = defaultFormValueInsurance;
        },
        handlePaginationStateInsurance: (state, action) => {
            const { payload } = action;
            state.paginationInsurance = payload;
        },
        // filters
        updateFiltersInsurance: (state, action) => {
            const { payload } = action;
            state.filtersInsurance = { ...state.filtersInsurance, ...payload };
        },
        resetFiltersInsurance: (state) => {
            state.filtersInsurance = {
                product_id: null,
                start_date: null,
                end_date: null,
            };
        },
        // insurance details
        setSelectedInsurance: (state, action) => {
            state.selectedInsurance = action.payload;
        },
        setShowInsuranceDetails: (state, action) => {
            state.showInsuranceDetails = action.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    changeInsuranceInitialState,
    handlePaginationStateInsurance,
    updateFiltersInsurance,
    resetFiltersInsurance,
    setSelectedInsurance,
    setShowInsuranceDetails,
} = insuranceSlice.actions;

export default insuranceSlice;
